import React from 'react'

function Newtypedocument() {
  return (
    <div>Newtypedocument</div>
  )
}

export default Newtypedocument